import { Container } from 'aurelia-dependency-injection';
import { Router } from 'aurelia-router';
import moment from 'moment';

// Parameters: options
// - container: grid cell container
// - containerOptions: grid cell options
// - route: route to navigate on click
// - paramsCallback: function to return parameters for route
// - hideLink: determines if link should be shown or not
// - isDate: handle date formatting
// - callback: link callback
function formatTableLink(options) {
    if (options.hideLink) {
        options.container.append(options.containerOptions.value);
        return;
    }

    const link = document.createElement('a');
    if (options.route) {
        const router = Container.instance.get(Router);
        link.href = router.generate(options.route, options.paramsCallback(options.containerOptions));
    }
    if (options.callback) {
        link.href = '#';
        link.addEventListener('click', event => {
            event.preventDefault();
            options.callback(options.containerOptions.data);
        });
    }
    link.innerHTML = options.isDate ? formatDate(options.containerOptions.value) : options.containerOptions.value;
    const div = document.createElement('div');
    div.style.textAlign = 'left';
    div.append(link);
    options.container.append(div);
}

function formatTableDate(cellInfo, showTime = false) {
  console.log(cellInfo);
    if(!cellInfo.value) return '';
    return moment.utc(cellInfo.value).local().format(`M/D/YYYY${showTime ? ' h:mm:ss a' : ''}`);
}


// Parameters: options
// - style: style of the button
// - label: text of the button
// - action: function to call when button is pressed
// - container: grid cell container
// - containerOptions: grid cell options
function creatTableButton(options) {
    const button = document.createElement('button');
    button.classList = `btn btn-${options.style}`;
    button.innerHTML = options.label;
    button.addEventListener('click', event => {
        options.action(options.containerOptions.data);
    });
    const div = document.createElement('div');
    div.style.textAlign = 'left';
    div.append(button);
    options.container.append(div);
}

function createButton(options) {
    const button = document.createElement('button');
    button.classList = `btn btn-${options.style}`;
    button.innerHTML = options.label;
    button.addEventListener('click', event => {
        options.action(options.containerOptions.data);
    });
    return button;
}

function createTableSelectInput(options) {
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.addEventListener('change', event => {
    options.action(options.containerOptions, event);
  });
  input.checked = options.isSelected;
  const div = document.createElement('div');
  div.style.textAlign = 'left';
  div.append(input);
  options.container.append(div);
}

function toTitleCase(str) {
    if (!str) return '';
    return str.replace(/\p{L}+('\p{L}+)?/gu, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    })
}

function toParsedFloat(number, precision = 4) {
  let num = parseFloat(number);
  return isNaN(num) ? Number(0).toFixed(precision) : num.toFixed(precision);
}

function calculateAllToFloat(...args) {
  let total = 0;
  args.forEach((arg) => {
    let num = parseFloat(arg);
    total += isNaN(num) ? 0 : num;
  });
  return total.toFixed(4);
}

function addLink(route, text, params) {
  const link = document.createElement('a');
  const router = Container.instance.get(Router);

  link.href = router.generate(route, params);
  link.innerHTML = text;

  const div = document.createElement('div');
  div.style.textAlign = 'left';
  div.append(link);
  return div;
}

export {
  formatTableLink,
  creatTableButton,
  toTitleCase,
  formatTableDate,
  createTableSelectInput,
  createButton,
  toParsedFloat,
  calculateAllToFloat,
  addLink
};

